import * as RequestUtil from "../http_request/RequestUtil.js";

/**
 * Unsubscribe from email notifications.
 * Supports both new token-based and legacy hash-based approaches.
 * 
 * @param {Object} tokenData - Object containing either {token} or {hash}
 * @param {string} applicationName - The application name (appkarma, cashkarma)
 * @param {Function} callback - Callback(errorInfo, responseInfo)
 */
export const unsubscribeAccount = function(tokenData, applicationName, callback) {
    let params = {};
    params["data_0"] = applicationName;
    
    // Support both new token-based and legacy hash-based approaches
    if (tokenData && typeof tokenData === 'object') {
        if (tokenData.token) {
            params["token"] = tokenData.token;
        } else if (tokenData.hash) {
            params["hash"] = tokenData.hash;
        }
    } else if (typeof tokenData === 'string') {
        // Legacy: if a string is passed, treat it as hash for backwards compatibility
        params["hash"] = tokenData;
    }
    
    var fullUrl = RequestUtil.createFullUrl("/app_all/browserweb_unsubscribe", params);
    RequestUtil.requestGET(fullUrl,
        function(errorInfo, respData) {
            if (errorInfo) {
                callback(errorInfo);
            } else {
                let responseInfo = {};
                callback(null, responseInfo);
            }
    });
}